<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn color="#c4c22c" fab x-small dark v-on="on"><v-icon>search</v-icon></v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="#c4c22c">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <!-- <v-btn dark text @click="dialog = false"></v-btn> -->
          </v-toolbar-items>
        </v-toolbar>
        <div class="reports">
        <h1>Lead Process ID: {{lead.lead_process_id}}<span class="h1-underline"></span></h1>
          <div class="container">
             <v-container>
                <v-row>
                  <v-col
                    :cols="8"
                  >
                    <v-card class="colunas">
                      <h2>Dados Primeiro Titular<span class="h2-underline"></span></h2>
                        <v-row>
                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Dados Pessoais
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in dadostitular1"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Rendimentos
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in rendimentostitular1"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                            
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Emprego
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in empregotitular1"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>

                          </v-col>

                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Dados Crédito
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in creditotitular1"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-col>

                        </v-row>

                        <h2>Dados Segundo Titular<span class="h2-underline"></span></h2>
                        <v-row>
                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Dados Pessoais
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in dadostitular2"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-col>
                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Rendimentos
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in rendimentostitular2"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                            
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Emprego
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in empregotitular2"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>

                          </v-col>

                          <v-col
                            :cols="4"
                          >
                            <div class="colunas-interiores">
                              <h2 class="sub-titulos-ficha">
                                Dados Crédito
                                <span class="h2-underline"></span>
                              </h2>
                              <div
                                  v-for="item in creditotitular2"
                                  :key="item.title"
                                >
                                <v-list-item v-if="item.value != ''">
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <b>{{ item.title }}</b> 
                                      <br>
                                      {{item.value}}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </div>
                          </v-col>

                        </v-row>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="4"
                  >
                    <v-card class="colunas">
                      <h2>Histórico<span class="h2-underline"></span></h2>
                          <v-timeline
                            align-top
                            dense
                            class="timeline-container"
                          >

                            <v-timeline-item
                              v-for="(hist, i) in historico"
                              :key="i"
                              fill-dot
                              right
                              small
                            >
                              <v-card class="elevation-2">
                                <v-card-title class="timeline-date">{{hist.data}}</v-card-title>
                                <v-card-text>
                                  <b>Resultado:</b> {{hist.resultado}}
                                  <br>
                                  <b>Estado:</b> {{hist.estado}}
                                </v-card-text>
                              </v-card>
                            </v-timeline-item>

                          </v-timeline>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
      name:'LeadDetail',
      props: ["lead"],
    data () {
      return {
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,

        dadostitular1: [],
        rendimentostitular1: [],
        empregotitular1: [],
        creditotitular1: [],
        dadostitular2: [],
        rendimentostitular2: [],
        empregotitular2: [],
        creditotitular2: [],
        
        item: 1,
        items: [],
        historico: [],
        
        listDadosPessoais1T: [
          "nome",
          "email",
          "telefone",
          'TÍTULO',
          'NOME COMPLETO',
          'CONTACT NAME',
          'SEXO',
          'DATA DE NASCIMENTO',
          '1ST PHONE',
          '2ND PHONE',
          '3RD PHONE',
          '4TH PHONE',
          '5TH PHONE',
          '6TH PHONE',
          '7TH PHONE',
          '8TH PHONE',
          'EMAIL',
          'ESTADO CÍVIL',
          'NACIONALIDADE/PAÍS',
          'NATURALIDADE/PAÍS',
          'TEM OUTRA NACIONALIDADE?',
          'FILHOS  CARGO',
          'DOCUMENTO DE IDENTIFICAÇÃO',
          'NÚMERO DO DOCUMENTO DE IDENTIFICAÇÃO',
          'CONTRIBUINTE',
          'DATA DE VALIDADE DO DOCUMENTO',
          'TIPO DE HABITAÇÃO',
          'NOME DA RUA/VIA',
          'Nº DE PORTA/ANDAR/LUGAR',
          'ADDRESS',
          'CITY',
          'CÓDIGO POSTAL',
          'POSTAL CODE',
          'MORADA FISCAL',
          'COUNTRY',
          'TEM RESIDÊNCIA NOUTRO PAÍS',
          'VIVE NESSA CASA DESDE DE'
        ],
        
        listFinanceiros1T: [
          'IBAN',
          'NÚMERO DO IBAN',
          'PRESTAÇÃO DA CASA',
          'RENDIMENTO MENSAL LÍQUIDO',
          'RENDIMENTOS NÃO COMPROVÁVEIS',
          'RENDIMENTOS PREDIAIS',
          'RENDIMENTOS VARIÁVEIS',
          'OUTROS RENDIMENTOS',
          'PENSÃO DE ALIMENTOS',
          'PENSÃO DE ALIMENTOS 2',
          'RENDA DA CASA',
          'ABERTURA DE CONTA',
        ],
        
        listPatronal1T: [
          'EXERCE CARGO PÚBLICO OU POLÍTICO',
          'ENTIDADE PATRONAL',
          'PROFISSÃO',
          'SECTOR DA PROFISSÃO',
          'TIPO DE CONTRATO',
        ],
        
        listCredito1T: [
          'VALOR EM DÍVIDA',
          'TIPO DE CRÉDITO',
          'FINALIDADE DO CRÉDITO',
          'FINALIDADE MAIS DETALHADA',
          'INCLUIR SEGUNDO TITULAR',
          'INCUMPRIMENTO',
          'MENSALIDADE',
          'MONTANTE',
          'ENTIDADE DO CRÉDITO',
          'CRÉDITO AUTOMOVEL',
          'CRÉDITO CLÁSSICO',
          'CARTÕES DE CRÉDITO',
          'DATA DO INÍCIO DO CRÉDITO',
          'DURAÇÃO',
          'DURAÇÃO DO CRÉDITO',
          'PRAZO',
          'PRÉ ADESSÃO HB',
          'PREÇO DE VENDA',
          'PRODUTO',
          'QUAL O TITULAR DO CREDITO A CONSOLIDAR',
          'Nº DE DOSSIER EXTERNO',
          'PEQUENO TEXTO A EXPLICAR A RAZÃO DO CRÉDITO',
          'TIPO DE SEGURO',
        ],

        listDadosPessoais2T: [
          '2T CÓDIGO POSTAL',
          '2T CONTRIBUINTE',
          '2T DATA DE NASCIMENTO',
          '2T DATA DE VALIDADE DO DOCUMENTO',
          '2T DOCUMENTO DE IDENTIFICAÇÃO',
          '2T E-MAIL',
          '2T ESTADO CÍVIL',
          '2T FILHOS  CARGO',
          '2T MORADA FISCAL',
          '2T NACIONALIDADE/PAÍS',
          '2T NATURALIDADE/PAÍS',
          '2T Nº DE PORTA/ANDAR/LUGAR',
          '2T NOME COMPLETO',
          '2T NOME DA RUA/VIA',
          '2T NÚMERO DO DOCUMENTO DE IDENTIFICAÇÃO',
          '2T SEXO','2T TELEFONE FIXO',
          '2T TELEMÓVEL',
          '2T TEM OUTRA NACIONALIDADE?',
          '2T TEM RESIDÊNCIA NOUTRO PAÍS',
          '2T TIPO DE HABITAÇÃO',
          '2T TÍTULO',
          '2T VIVE NESSA CASA DESDE DE',
        ],
        
        listFinanceiros2T: [
          '2T OUTROS RENDIMENTOS',
          '2T PENSÃO DE ALIMENTOS',
          '2T PENSÃO DE ALIMENTOS',
          '2T PRESTAÇÃO DA CASA',
          '2T RENDA DA CASA',
          '2T RENDIMENTO MENSAL LÍQUIDO',
          '2T RENDIMENTOS NÃO COMPROVÁVEIS',
          '2T RENDIMENTOS PREDIAIS',
          '2T RENDIMENTOS VARIÁVEIS',
        ],
        
        listPatronal2T: [
          '2T ENTIDADE PATRONAL',
          '2T EXERCE CARGO PÚBLICO OU POLÍTICO. QUAL',
          '2T PROFISSÃO',
          '2T SECTOR DA PROFISSÃO',
          '2T TIPO DE CONTRATO',
        ],
        
        listCredito2T: [
          '2T CARTÕES DE CRÉDITO',
          '2T CRÉDITO AUTOMOVEL',
          '2T CRÉDITO CLÁSSICO',
        ],
      }
    },
    methods: {
      groupLeadDetails: async function () {
        let dados = this.lead

        for(let prop in dados) {
          if(prop == "lead_details") {
            for(let i in dados[prop]) {
              if(this.listDadosPessoais1T.includes(i)) {
                this.dadostitular1.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listFinanceiros1T.includes(i)) {
                this.rendimentostitular1.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listPatronal1T.includes(i)) {
                this.empregotitular1.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listCredito1T.includes(i)) {
                this.creditotitular1.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }

              else if(this.listDadosPessoais2T.includes(i)) {
                this.dadostitular2.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listFinanceiros2T.includes(i)) {
                this.rendimentostitular2.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listPatronal2T.includes(i)) {
                this.empregotitular2.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
              else if(this.listCredito2T.includes(i)) {
                this.creditotitular2.push(
                  {title: i.charAt(0).toUpperCase() + i.substring(1).toLowerCase(), value: dados[prop][i]}
                )
              }
            }
          }
          else {
            if(this.listDadosPessoais1T.includes(prop)) {
              this.dadostitular1.push(
                {title: prop.charAt(0).toUpperCase() + prop.substring(1).toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listFinanceiros1T.includes(prop)) {
              this.rendimentostitular1.push(
                {title: prop.charAt(0).toUpperCase() + prop.substring(1).toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listPatronal1T.includes(prop)) {
              this.empregotitular1.push(
                {title: prop.charAt(0).toUpperCase() + prop.substring(1).toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listCredito1T.includes(prop)) {
              this.creditotitular1.push(
                {title: prop.toLowerCase(), value: dados[prop]}
              )
            }

            else if(this.listDadosPessoais2T.includes(prop)) {
              this.dadostitular2.push(
                {title: prop.toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listFinanceiros2T.includes(prop)) {
              this.rendimentostitular2.push(
                {title: prop.toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listPatronal2T.includes(prop)) {
              this.empregotitular2.push(
                {title: prop.toLowerCase(), value: dados[prop]}
              )
            }
            else if(this.listCredito2T.includes(prop)) {
              this.creditotitular2.push(
                {title: prop.toLowerCase(), value: dados[prop]}
              )
            }
          }
        }
      },
      collect_lead_data: async function () {
        let url = "https://app.reorganiza.pt/public/api/lead-process-logs/results/"+this.lead.lead_process_id

        const dados = await this.call_api_get(url)

        this.historico = dados
      },
      call_api_get: async function (url) {
          try {
              var response = await fetch(url, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  }
              })
              var result = await response.json()
              return result
          }
          catch (error) {
              console.error('Error:', error)
              return 'Error: ' + error
          }
      }
    },
    mounted: async function () {
      await this.collect_lead_data()
      await this.groupLeadDetails()
    },
    watch: {
      lead: async function (newLead) {
        this.lead = newLead
        this.dadostitular1 = []
        this.rendimentostitular1 = []
        this.empregotitular1 = []
        this.creditotitular1 = []
        this.dadostitular2 = []
        this.rendimentostitular2 = []
        this.empregotitular2 = []
        this.creditotitular2 = []
        await this.collect_lead_data()
        await this.groupLeadDetails()
      }
    }
  }
</script>

<style scoped>
    h1{
      margin-left: 40px;
      color: black;
      font-size: 20px;
      text-transform: uppercase;
      margin-top: 50px;
      position: relative;
      display: block;
    }
    .h1-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 60px;
      height: 3px;
      background-color: black;
      margin-bottom: -6px;
    }

    h2{
      margin-left: 40px;
      color: black;
      font-size: 14px;
      text-transform: uppercase;
      position: relative;
      display: block;
    }
    .h2-underline{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 80%;
      height: 1px;
      background-color: black;
      margin-bottom: -6px;
    }

    .container{
      margin: 10px 0px;
      max-width: 100%;
    }

    .colunas{
      padding: 20px 0;
      margin-top: 10px;
    }

    .colunas-interiores{
      padding: 20px 40px;
    }

    .v-list-item{
      min-height: 10px;
      padding:0;
      margin-bottom: 0!important;
    }

    .v-list-item__content{
      padding:8px 0;
    }

    .v-list-item__title{
      font-size:14px;
    }

    h3{
      font-size:14px;
      margin-bottom:10px;
    }
    .v-item-group{
      padding: 0 30px;
    }
    .v-list-item__icon{
      margin-right: 10px!important;
      margin-left: 20px;
    }

    .timeline-date {
      font-size: 14px;
      padding-bottom: 5px!important;
    }

    .timeline-container {
      margin-top: 20px;
      padding-right: 25px;
    }

    .sub-titulos-ficha {
      margin-left: 0px;
      margin-bottom: 5px;
    }
   
</style>>
   